export const CASHIER_QUICK_DEPOSIT = 'quick-deposit';
